import { Link } from "react-router-dom";
import { CONTACT, CTA, STUDIO } from "@/lib/siteData";

// The orange footer that closes every page. Measurements come from 20:193, which
// is the only frame that draws it in full: 408px tall, logotype at 222x86 on the
// left, 40px headline centred with a 20px line under it, a white button with an
// orange label, contact block on the left and social links on the right, then the
// legal line.
//
// An earlier version of this was built from a thumbnail and had the headline at
// 22px — less than half the designed size.
export const Footer = () => (
    <footer className="bg-brand text-paper">
        <div className="mx-auto grid max-w-[1440px] gap-x-10 gap-y-12 px-6 py-[80px] md:px-[75px] lg:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)]">
            {/* Left: logotype over the contact block. */}
            <div className="flex flex-col gap-8">
                <img
                    src="/images/brand/logo-principal-branca.png"
                    alt={STUDIO.name}
                    width={1425}
                    height={551}
                    className="h-[86px] w-auto self-start"
                />
                <dl className="space-y-2 text-[clamp(15px,1.4vw,20px)]">
                    <div className="flex flex-wrap gap-x-3">
                        <dt className="font-bold">E-MAIL</dt>
                        <dd className="font-light">
                            <a
                                href={`mailto:${CONTACT.email}`}
                                className="link-sweep"
                            >
                                {CONTACT.email}
                            </a>
                        </dd>
                    </div>
                </dl>
            </div>

            {/* Middle: the closing pitch and CTA. */}
            <div className="flex max-w-[489px] flex-col items-center gap-5 text-center lg:justify-center">
                <p className="type-display text-[clamp(26px,2.9vw,40px)] leading-[1.1]">
                    {CTA.footer.headline}
                </p>
                <p className="max-w-[381px] text-[clamp(15px,1.4vw,20px)]">
                    {CTA.footer.subhead[0]}
                    <strong className="font-bold">{CTA.footer.subhead[1]}</strong>
                </p>
                <Link
                    to="/contato"
                    className="type-display inline-flex h-[50px] w-[269px] items-center justify-center bg-paper text-action text-brand btn-sweep [--sweep:theme(colors.brand.DEFAULT/12%)]"
                >
                    {CTA.footer.action}
                </Link>
            </div>

            {/* Right: social links. */}
            <nav
                aria-label="Redes sociais"
                className="flex flex-col gap-4 text-[clamp(15px,1.4vw,20px)] font-bold lg:items-end lg:justify-center"
            >
                <a
                    href={CONTACT.instagram.href}
                    target="_blank"
                    rel="noreferrer"
                    className="link-sweep"
                >
                    Instagram
                </a>
                <a
                    href={CONTACT.linkedin.href}
                    target="_blank"
                    rel="noreferrer"
                    className="link-sweep"
                >
                    LinkedIn
                </a>
                <a
                    href={CONTACT.behance.href}
                    target="_blank"
                    rel="noreferrer"
                    className="link-sweep"
                >
                    Behance
                </a>
            </nav>
        </div>

        <div className="mx-auto flex max-w-[1440px] flex-col items-center gap-1.5 px-6 pb-[31px] text-center">
            <Link to="/politica-de-privacidade" className="text-[14px] font-bold">
                Política de Privacidade e Termos de Serviço
            </Link>
            <p className="text-[13px] text-white/90">© 2026 Rock Fox Studio — All rights reserved</p>
            <p className="text-[12.5px] font-medium text-white/80">
                Desenvolvido por{" "}
                <span className="text-shimmer font-semibold tracking-wide">Arthur Santinati</span>
            </p>
        </div>
    </footer>
);
